import { post } from './api'
import { getServerInfo } from '../utils/helpers/networkInfo.helper';

const serverUrl = getServerInfo('api');
export class AuthService {
  static login(data) {
    return post(`${serverUrl}auth/login`, data)
  }
}
